import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

export const Regulations = () => {
  const [activeIndex, setActiveIndex] = useState(0); // Default first item open
  const [lang, setLang] = useState("id");

  useEffect(() => {
    try {
      const stored = localStorage.getItem("regulations_lang");
      if (stored === "id" || stored === "en") setLang(stored);
    } catch (e) {
      // ignore
    }
    window.scrollTo(0, 0);
  }, []);

  const setLanguage = (l) => {
    if (l !== "id" && l !== "en") return;
    setLang(l);
    try {
      localStorage.setItem("regulations_lang", l);
    } catch (e) {
      // ignore
    }
  };

  const toggleAccordion = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  const regulations = [
    {
      title: {
        id: "A. PENDAFTARAN & KELAYAKAN PESERTA",
        en: "A. REGISTRATION & ELIGIBILITY",
      },
      content: {
        id: `
          <ul class="list-disc pl-5 mt-2">
            <li>Usia minimal 18 tahun pada hari perlombaan.</li>
            <li>Pendaftaran bersifat pribadi, tidak dapat dialihkan dan tidak dapat dikembalikan (non-refundable).</li>
            <li><strong>Biaya Perubahan Kategori</strong>
              <ul class="list-disc pl-8 mt-2">
                <li>Naik Kategori: Anda wajib membayar selisih biaya pendaftaran ditambah biaya administrasi sebesar Rp 200.000.</li>
                <li>Turun Kategori: Biaya tetap sama (tidak ada pengembalian dana).</li>
                <li>Perubahan hanya boleh dilakukan 1 (satu) kali.</li>
              </ul>
            </li>
            <li>Berlari menggunakan nama orang lain atau tanpa pendaftaran resmi akan langsung didiskualifikasi dan dikenakan diskualifikasi permanen dari seluruh ajang kompetisi di masa mendatang.</li>
            <li>Peserta harus berada dalam kondisi kesehatan yang baik dan mampu menyelesaikan jalur lintasan. Penyelenggara berhak meminta surat keterangan medis jika diperlukan.</li>
            <li>Peserta menanggung risiko sendiri dan wajib menyetujui pelepasan tanggung jawab (panitia bebas dari tuntutan cedera/kehilangan) pada saat melakukan pendaftaran.</li>
          </ul>
        `,
        en: `
          <ul class="list-disc pl-5 mt-2">
            <li>Minimum age of 18 years on race day.</li>
            <li>Registration is personal, non-transferable, and non-refundable.</li>
            <li><strong>Category Change Fees</strong>
              <ul class="list-disc pl-8 mt-2">
                <li>Upgrading Categories: You must pay the difference in fees plus an administration fee of Rp.200,000.</li>
                <li>Downgrading Categories: The fee stays the same (no refunds will be given).</li>
                <li>Changes are only allowed once.</li>
              </ul>
            </li>
            <li>Running under another person's name or without official registration will result in immediate and permanent disqualification from all future events.</li>
            <li>Participants must be in good health and capable of completing the course. Organizers reserve the right to request a medical certificate.</li>
            <li>Participants run at their own risk and must agree to a liability waiver upon registration.</li>
          </ul>
        `,
      },
    },
    {
      title: {
        id: "B. PERALATAN WAJIB",
        en: "B. MANDATORY GEAR",
      },
      content: {
        id: `
          <p class="mt-2">Peralatan wajib yang harus dibawa oleh <strong>semua pelari</strong>:</p>
          <ul class="list-disc pl-5 mt-2">
            <li>Sistem hidrasi pribadi, sesuai dengan kebijakan no-disposable-cup kami.</li>
            <li>Ponsel charged penuh dengan kontak darurat tersimpan (termasuk nomor darurat panitia). Power bank sangat direkomendasikan.</li>
          </ul>

          <p class="mt-6 font-semibold">Sangat Direkomendasikan:</p>
          <ul class="list-disc pl-5 mt-2">
            <li>Headlamp (akan menjadi wajib jika kondisi gelap)</li>
            <li>Waterproof jacket atau raincoat (dapat menjadi wajib tergantung cuaca hari-H)</li>
            <li>Trekking poles</li>
            <li>Whistle atau emergency signalling</li>
            <li>Personal nutrition (energy gels, bars, etc.)</li>
            <li>Penutup kepala (buff atau topi) dan sarung tangan</li>
            <li>Emergency blanket</li>
          </ul>
        `,
        en: `
          <p class="mt-2">The mandatory gear required for <strong>all runners</strong>:</p>
          <ul class="list-disc pl-5 mt-2">
            <li>A personal hydration system, in accordance with our no-disposable-cup policy.</li>
            <li>A fully charged mobile phone with emergency contacts saved (including the organizer's emergency number). A power bank is recommended.</li>
          </ul>

          <p class="mt-6 font-semibold">Highly Recommended Gear:</p>
          <ul class="list-disc pl-5 mt-2">
            <li>Headlamp (may become mandatory if conditions are dark)</li>
            <li>Waterproof jacket or raincoat (may become mandatory depending on race-day weather)</li>
            <li>Trekking poles</li>
            <li>Whistle or emergency signalling</li>
            <li>Personal nutrition (energy gels, bars, etc.)</li>
            <li>Head covering (buff or hat) and gloves</li>
            <li>Emergency blanket</li>
          </ul>
        `,
      },
    },
    {
      title: {
        id: "C. NOMOR DADA & PENENTUAN WAKTU (TIMING)",
        en: "C. BIB NUMBER & TIMING",
      },
      content: {
        id: `
          <ul class="list-disc pl-5 mt-2">
            <li>Nomor dada harus dipakai terlihat di bagian depan tubuh setiap saat selama perlombaan.</li>
            <li>Jangan melipat, memotong, mengubah, atau menutupi nomor dada dengan cara apa pun.</li>
            <li>Laporkan nomor dada yang hilang atau rusak segera kepada petugas perlombaan.</li>
            <li>Melepaskan nomor dada selama perlombaan berakibat diskualifikasi.</li>
            <li>Jika menggunakan chip timing, chip tersebut tidak boleh dirusak atau dilepas sampai setelah garis akhir.</li>
          </ul>
        `,
        en: `
          <ul class="list-disc pl-5 mt-2">
            <li>Must be worn visibly on the front of the body at all times during the race.</li>
            <li>Do not fold, cut, alter, or cover the bib number in any way.</li>
            <li>Report lost or damaged bibs immediately to race officials.</li>
            <li>Removing the bib during the race results in disqualification.</li>
            <li>If using a timing chip, it must not be damaged or removed until after the finish line.</li>
          </ul>
        `,
      },
    },
    {
      title: {
        id: "D. ATURAN PACER DAN BANTUAN KRU",
        en: "D. PACER AND CREW SUPPORT RULES",
      },
      content: {
        id: `
          <ul class="list-disc pl-5 mt-2">
            <li>Pacer pribadi tidak diperbolehkan di manapun di jalur lintasan kecuali ditentukan oleh penyelenggara.</li>
            <li>Bantuan dari anggota kru hanya diperbolehkan di stasiun bantuan yang ditentukan.</li>
            <li>Menerima bantuan di luar titik-titik yang ditentukan ini (misalnya, dari kendaraan, sepeda motor, atau sepeda) dilarang dan akan berakibat diskualifikasi.</li>
            <li>Pacer dan kru harus mematuhi aturan perlombaan dan tidak dapat memberikan bantuan fisik di luar zona stasiun bantuan.</li>
          </ul>
        `,
        en: `
          <ul class="list-disc pl-5 mt-2">
            <li>Personal pacers are not allowed anywhere on the course unless specified by the organizers.</li>
            <li>Crew support is only permitted at designated aid stations.</li>
            <li>Receiving assistance outside these designated points (e.g., from vehicles, motorcycles, or bicycles) is prohibited and will result in disqualification.</li>
            <li>Pacers and crew must adhere to race rules and cannot provide physical assistance outside the aid station zones.</li>
          </ul>
        `,
      },
    },
    {
      title: {
        id: "E. POS PEMERIKSAAN & BATAS WAKTU (CUT-OFF TIMES)",
        en: "E. CHECKPOINTS & CUT-OFF TIMES",
      },
      content: {
        id: `
          <ul class="list-disc pl-5 mt-2">
            <li>Perlombaan harus diselesaikan dalam waktu yang ditentukan untuk masing-masing kategori.</li>
            <li>Peserta wajib mencapai setiap pos pemeriksaan untuk mengambil gelang check point sesuai kategori yang diikuti dan memakainya pada gelang tangan masing-masing peserta.</li>
            <li>Peserta yang melebihi batas waktu (cut-off) akan ditarik dari perlombaan, didampingi dengan aman keluar dari jalur lintasan, dan diangkut kembali ke area finish sesuai ketersediaan.</li>
            <li>Setelah batas waktu, jalur lintasan akan ditutup demi alasan keselamatan; peserta wajib mematuhi instruksi dari petugas resmi.</li>
          </ul>
        `,
        en: `
          <ul class="list-disc pl-5 mt-2">
            <li>The race must be completed within the time specified for each category.</li>
            <li>Participants must reach every checkpoint to collect the corresponding checkpoint wristband for their category and wear it on their wrist.</li>
            <li>Participants who exceed the cut-off time will be withdrawn from the race, safely escorted off the course, and transported back to the finish area as available.</li>
            <li>After the cut-off time, the course will be closed for safety reasons; participants must comply with instructions from official personnel.</li>
          </ul>
        `,
      },
    },
    {
      title: {
        id: "F. PROTOKOL PENGUNDURAN DIRI (DNF)",
        en: "F. DID NOT FINISH (DNF) PROTOCOL",
      },
      content: {
        id: `
          <ul class="list-disc pl-5 mt-2">
            <li>Peserta yang mengundurkan diri wajib segera memberitahu petugas perlombaan terdekat dan menyerahkan nomor dada mereka.</li>
            <li>Setelah mengundurkan diri, dilarang keras melanjutkan perjalanan di jalur lintasan.</li>
            <li>Penarikan diri darurat dapat dilakukan dengan menghubungi pusat kendali perlombaan melalui ponsel atau memberi tahu petugas lintasan (race marshal).</li>
            <li>Transportasi kembali ke garis akhir akan diatur berdasarkan lokasi dan ketersediaan; peserta tidak boleh mengandalkan transportasi pribadi.</li>
          </ul>
        `,
        en: `
          <ul class="list-disc pl-5 mt-2">
            <li>Withdrawing participants must immediately notify the nearest race official and surrender their bib number.</li>
            <li>After withdrawing, it is strictly prohibited to continue traveling on the course.</li>
            <li>Emergency withdrawal can be done by contacting race control via mobile phone or notifying a race marshal.</li>
            <li>Transportation back to the finish line will be arranged based on location and availability; participants should not rely on private transport.</li>
          </ul>
        `,
      },
    },
    {
      title: {
        id: "G. PENGAJUAN PROTES",
        en: "G. FILING A PROTEST (SUBMITTING AN OBJECTION)",
      },
      content: {
        id: `
          <p>Semua keberatan terhadap keputusan panitia atau rute lomba harus disampaikan secara tertulis, disertai dengan deposit Rp1.000.000 (tidak dapat dikembalikan jika keberatan dianggap tidak valid), dalam waktu dua jam setelah peserta tiba di garis finish. Hakim lomba, yang terdiri dari:</p>
          <ul class="list-disc pl-5 mt-2">
            <li>Juri Lari.</li>
            <li>Race Director.</li>
            <li>Pihak kompeten yang dipilih oleh direktur lomba.</li>
          </ul>
          <p>Hakim lomba berwenang membuat keputusan final yang tidak dapat diganggu gugat.</p>
        `,
        en: `
          <p>These are the rules for challenging the judging or competition results:</p>
          <ul class="list-disc pl-5 mt-2">
            <li>You must pay a Rp 500,000 fee to the judging committee before you file a protest.</li>
            <li>You must bring relevant proof to support your objection.</li>
          </ul>
          <p><strong>Protest Fee Refund/Forfeiture Terms:</strong></p>
          <ul class="list-disc pl-5 mt-2">
            <li>If the Protest is Proven: The latest competition results will be updated, and the protest fee (Rp. 500,000.00) will be refunded.</li>
            <li>If the Protest is Not Proven: The protest fee that has been submitted will be forfeited (not refunded).</li>
          </ul>
        `,
      },
    },
    {
      title: {
        id: "H. TANGGUNG JAWAB LINGKUNGAN & ETIKA LINTASAN",
        en: "H. ENVIRONMENTAL RESPONSIBILITY & COURSE ETIQUETTE",
      },
      content: {
        id: `
          <ul class="list-disc pl-5 mt-2">
            <li>Dilarang membuang sampah (termasuk bungkus gel, botol, tisu) di lintasan. Bawa sampah hingga tempat pembuangan. Pelanggaran berakibat diskualifikasi segera.</li>
            <li>Wajib tetap berada di jalur yang ditandai. Memotong jalur (shortcutting) atau menyimpang dari rute dilarang dan dapat menyebabkan diskualifikasi.</li>
            <li>Hormati sesama pelari, sukarelawan, penduduk lokal, serta lingkungan alam. Hindari mengganggu satwa liar dan tumbuhan.</li>
            <li>Gunakan toilet yang disediakan. Dilarang buang air besar sembarangan di lintasan.</li>
          </ul>
        `,
        en: `
          <ul class="list-disc pl-5 mt-2">
            <li>Littering (including gel wrappers, bottles, tissues) on the course is prohibited. Carry all trash to disposal points. Violation results in immediate disqualification.</li>
            <li>Must stay on the marked trail. Shortcutting or deviating from the route is prohibited and may lead to disqualification.</li>
            <li>Respect fellow runners, volunteers, locals, and the natural environment. Avoid disturbing wildlife and plants.</li>
            <li>Use provided toilets. Defecating indiscriminately on the course is prohibited.</li>
          </ul>
        `,
      },
    },
    {
      title: {
        id: "I. MEDIS DAN KESELAMATAN",
        en: "I. MEDICAL AND SAFETY",
      },
      content: {
        id: `
          <ul class="list-disc pl-5 mt-2">
            <li>Tulis kondisi medis, alergi, dan kontak darurat dengan jelas di belakang nomor dada.</li>
            <li>Petugas medis/penyisir lintasan berhak menghentikan/menarik peserta yang dinilai berisiko bagi keselamatan atau kesehatan.</li>
            <li>Peserta menanggung semua biaya perawatan medis dan evakuasi (jika diperlukan).</li>
            <li>Pertolongan Pertama: Dianjurkan membawa kotak P3K kecil dan menguasai keterampilan penyelamatan diri dasar.</li>
          </ul>
        `,
        en: `
          <ul class="list-disc pl-5 mt-2">
            <li>Clearly write medical conditions, allergies, and emergency contacts on the back of the bib.</li>
            <li>Medical/sweeper personnel have the right to stop/withdraw participants deemed a risk to safety or health.</li>
            <li>Participants bear all costs of medical treatment and evacuation (if necessary).</li>
            <li>First Aid: Carrying a small first aid kit and having basic self-rescue skills is recommended.</li>
          </ul>
        `,
      },
    },
    {
      title: {
        id: "J. ASURANSI KECELAKAAN PRIBADI & EVAKUASI",
        en: "J. PERSONAL INSURANCE & EVACUATION",
      },
      content: {
        id: `
          <ul class="list-disc pl-5 mt-2">
            <li>Setiap peserta lomba wajib memiliki asuransi kecelakaan.</li>
            <li>Jika peserta tidak memiliki asuransi dan harus dirujuk ke rumah sakit, biaya rumah sakit akan ditanggung oleh peserta.</li>
            <li>Evakuasi kecelakaan akan dilakukan jika terjadi kecelakaan dan transportasi tersedia.</li>
            <li>Pilihan evakuasi sepenuhnya merupakan keputusan dari panitia, yang akan memprioritaskan keselamatan pelari.</li>
          </ul>
        `,
        en: `
          <p><strong>1. Accident Insurance</strong></p>
          <ul class="list-disc pl-5 mt-2">
            <li>Every participant must have their own accident insurance.</li>
            <li>If a participant doesn't have insurance and needs hospital treatment, they must pay for the hospital costs themselves.</li>
          </ul>
          <p class="mt-2"><strong>2. Accident Evacuation</strong></p>
          <ul class="list-disc pl-5 mt-2">
            <li>Evacuation will be provided only if an accident occurs and if transportation is available.</li>
            <li>The committee has the final say on the evacuation method, always prioritizing the runner's safety first.</li>
          </ul>
        `,
      },
    },
    {
      title: {
        id: "K. KODE ETIK",
        en: "K. CODE OF CONDUCT",
      },
      content: {
        id: `
          <ul class="list-disc pl-5 mt-2">
            <li>Pelecehan, penyalahgunaan, diskriminasi, atau segala bentuk pelanggaran perilaku terhadap siapa pun yang terlibat dalam acara tidak akan ditoleransi.</li>
            <li>Penggunaan alkohol atau obat-obatan terlarang sebelum atau selama perlombaan dilarang.</li>
            <li>Peserta harus mengikuti semua instruksi yang diberikan oleh petugas perlombaan, sukarelawan, dan personel darurat tanpa membantah.</li>
            <li>Aturan anti-doping berlaku jika relevan; pelanggaran akan menyebabkan diskualifikasi dan sanksi lebih lanjut.</li>
          </ul>
        `,
        en: `
          <ul class="list-disc pl-5 mt-2">
            <li>Harassment, abuse, discrimination, or any form of behavioral violation against anyone involved in the event will not be tolerated.</li>
            <li>The use of alcohol or illegal drugs before or during the race is prohibited.</li>
            <li>Participants must follow all instructions given by race officials, volunteers, and emergency personnel without argument.</li>
            <li>Anti-doping rules apply if relevant; violations will lead to disqualification and further sanctions.</li>
          </ul>
        `,
      },
    },
    {
      title: {
        id: "L. KEADAAN KAHAR (FORCE MAJEURE)",
        en: "L. FORCE MAJEURE",
      },
      content: {
        id: `
          <ul class="list-disc pl-5 mt-2">
            <li>Penyelenggara berhak untuk membatalkan, menunda, atau mengubah acara (termasuk modifikasi jalur atau perubahan jarak) karena cuaca ekstrem, bencana alam, atau keadaan darurat lainnya.</li>
            <li>Biaya pendaftaran tidak akan dikembalikan dalam kasus-kasus tersebut.</li>
            <li>Peserta disarankan untuk bersiap menghadapi kondisi yang tidak terduga dan selalu memprioritaskan keselamatan.</li>
          </ul>
        `,
        en: `
          <ul class="list-disc pl-5 mt-2">
            <li>The organizer reserves the right to cancel, postpone, or alter the event (including course modification or distance changes) due to extreme weather, natural disaster, or other emergencies.</li>
            <li>Registration fees will not be refunded in such cases.</li>
            <li>Participants are advised to be prepared for unexpected conditions and always prioritize safety.</li>
          </ul>
        `,
      },
    },
  ];

  return (
    <>
      <section className="w-full min-h-screen py-20 bg-white text-slate-700">
        <div className="container mx-auto  max-w-6xl">
          <div className="max-w-6xl mx-auto space-y-6">
            {/* Switcher updated to match SuratPernyataan style (grouped buttons, top-right) */}
            <div className="flex px-4 justify-end">
              <div
                className="inline-flex rounded-md shadow-sm"
                role="group"
                aria-label="Language switcher"
              >
                <button
                  onClick={() => setLanguage("id")}
                  aria-pressed={lang === "id"}
                  className={`px-4 py-1 text-sm font-medium transition ${
                    lang === "id"
                      ? "bg-slate-700 text-white rounded-l-md"
                      : "bg-white text-slate-700 border border-slate-200 rounded-l-md"
                  }`}
                >
                  Bahasa (ID)
                </button>
                <button
                  onClick={() => setLanguage("en")}
                  aria-pressed={lang === "en"}
                  className={`px-4 py-1 text-sm font-medium transition ${
                    lang === "en"
                      ? "bg-slate-700 text-white rounded-r-md"
                      : "bg-white text-slate-700 border border-slate-200 rounded-r-md"
                  }`}
                >
                  English
                </button>
              </div>
            </div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              viewport={{ once: true }}
            >
              <div className="join join-vertical w-full">
                {regulations.map((reg, index) => (
                  <div
                    key={index}
                    className="collapse collapse-arrow join-item group"
                  >
                    <input
                      type="radio"
                      name="race-regulations-accordion"
                      checked={activeIndex === index}
                      onChange={() => toggleAccordion(index)}
                    />
                    <div
                      className={`collapse-title text-left text-base font-medium uppercase transition-colors duration-200
          ${activeIndex === index ? "text-slate-700" : "text-gray-600"} 
          group-hover:text-slate-700`}
                    >
                      {lang === "id" ? reg.title.id : reg.title.en}
                    </div>
                    <div
                      className="collapse-content text-left text-base text-gray-600"
                      dangerouslySetInnerHTML={{
                        __html: lang === "id" ? reg.content.id : reg.content.en,
                      }}
                    />
                  </div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Regulations;
